<template>
    <div>
        <el-aside class="menu-aside">
            <el-row class="center">
                    <el-avatar shape="square" :size="70" :src="propertyLogo"></el-avatar>
                <div class="name">
                    <h3 @click="choosePropertyName">{{propertyName}}</h3>
                </div>
            </el-row>

            <el-menu mode="vertical" default-active="/ma/property" style="width: 280px" active-text-color="#AB82FF" router>
                <el-menu-item index="/ma/property"><i class="el-icon-office-building"/>Property</el-menu-item>
                <el-menu-item index="/ma/pro"><i class="el-icon-document"/>Forms</el-menu-item>
                <el-menu-item index="/ma/CheckListType"><i class="el-icon-document-checked"/>Checklist Template</el-menu-item>

                <el-submenu index="/ma/bulletin">
                    <template slot="title">
                        <i class="el-icon-data-board"></i>
                        <span>Bulletin</span>
                    </template>

                    <el-menu-item-group>
                        <el-menu-item index="/ma/bulletin/news"><i class="el-icon-postcard"/>News</el-menu-item>
                        <el-menu-item index="/ma/bulletin/docs"><i class="el-icon-document-copy"/>Documents</el-menu-item>
                        <el-menu-item index="/ma/bulletin/lostFound"><i class="el-icon-search"/>Lost & Found</el-menu-item>
                        <el-menu-item index="/ma/bulletin/calendar"><i class="el-icon-date"/>Calendar</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

                <el-submenu index="/ma/facility">
                    <template slot="title">
                        <i class="el-icon-collection"></i>
                        <span>Facility</span>
                    </template>

                    <el-menu-item-group>
                        <el-menu-item index="/ma/facility/facilityType"><i class="el-icon-copy-document"/>Facility Category</el-menu-item>
                        <el-menu-item index="/ma/facility/facilityList"><i class="el-icon-notebook-2"/>Facility List</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

                <el-menu-item index="/ma/vote"><i class="el-icon-edit-outline"/>Voting</el-menu-item>
                <el-menu-item index="/ma/blackList"><i class="el-icon-document-delete"/>Black List</el-menu-item>

                <el-submenu index="/ma/orders">
                    <template slot="title">
                        <i class="el-icon-s-order"></i>
                        <span>Orders</span>
                    </template>

                    <el-menu-item-group>
                        <el-menu-item index="/ma/orders/facilityBooking"><i class="el-icon-notebook-1"/>Facility Order</el-menu-item>
                        <el-menu-item index="/ma/orders/formsOrders"><i class="el-icon-tickets"/>Forms Order</el-menu-item>
                        <el-menu-item index="/ma/orders/estatePayment"><i class="el-icon-money"/>Estate payment</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

                <el-menu-item index="/ma/register"><i class="el-icon-receiving"/>Register</el-menu-item>
            </el-menu>
        </el-aside>

        <el-dialog
                :visible.sync="dialogVisible"
                align="center"
                title="Choose Property"
                width="30%">
            <el-select placeholder="Please select your choice" v-model="propertyId">
                <el-option
                        :key="item.propertyId"
                        :label="item.propertyName"
                        :value="item.propertyId"
                        v-for="item in data">
                </el-option>
            </el-select>
            <el-button @click="choose(propertyId)" type="primary">Change</el-button>
        </el-dialog>
    </div>
</template>

<script>
    import {allProperty, updateSessionProperty} from "@/api/AuthApi";
    import {mapGetters} from "vuex/dist/vuex.esm.browser";

    export default {
        name: "SideBar",
        data() {
            return {
                data: [],
                active: '/ma/propertyMain',
                propertyId: {},
                userInfo: '',
                dialogVisible: false
            }
        },
        methods: {
            logOut() {
                this.$router.push('/');
                this.$store.commit('setUserInfo', null)
            },
            choosePropertyName() {
                this.dialogVisible = true;
                this.propertyId = this.userInfo.propertyId;
                allProperty(this.userInfo.userId).then(
                    res => {
                        this.data = res.data
                    }
                )
            },
            backToEazable() {
                this.$router.push('/eazable/property')
            },
            choose(pid) {
                updateSessionProperty({"propertyId": pid}).then(res => {
                    this.dialogVisible = false;
                    const reData = res.data;
                    const userInfo = this.$copy(this.$store.state.userInfo);
                    userInfo.propertyId = reData.propertyId;
                    userInfo.propertyLogo = reData.propertyLogo;
                    userInfo.propertyName = reData.propertyName;
                    this.$store.commit('setUserInfo', userInfo);
                    this.$message.success('Switching Property Success')
                })
            }
        },
        computed: mapGetters({
            userName: "getUserName",
            propertyName: 'getPropertyName',
            propertyLogo: 'getPropertyLogo',
            isSuper: 'isSuperMa',
            isEazable: 'isEazable'
        })
    }
</script>

<style scoped>
    .el-avatar {
        margin: 10px;
    }

    .el-menu {
        font-weight: bold;
    }

    .name {
        font-size: 15px;
        padding: 35px 0;
    }

    .center {
        display: flex;
        margin: 10px 0 15px 10px;
    }

    .el-menu-item-group {
        margin-left: 5px;
    }
</style>